export default [
  {
    path: '/kit/',
    name: 'kit',
    title: 'Kit',
    component: () => import('../views/KitView.vue'),
    redirect: { name: 'kit-listar' },
    children: [
      {
        path: 'welcome',
        name: 'kit-listar',
        meta: {
          title: 'Kits de produto',
        },
        component: () => import('../views/KitWelcomeView.vue'),
      },
      {
        path: 'add',
        name: 'kit-cadastrar',
        meta: {
          title: 'Kit cadastrar',
        },
        component: () => import('../views/KitFormView.vue'),
      },
      {
        path: ':id',
        name: 'kit-editar',
        meta: {
          title: 'Kit editar',
        },
        component: () => import('../views/KitFormView.vue'),
      },
    ],
  },
];
